import $ from 'jquery'

$(document).on('click', '.bhub-accordion-heading', function () {
  $(this).find('.expander').toggleClass('expanded')
  var $accordionContent = $(this).next('.bhub-accordion-content')
  $accordionContent.slideToggle()
  $(this).parent().siblings().find('.bhub-accordion-content').slideUp()
  $(this).parent().siblings().find('.expander').removeClass('expanded')
})

// Swticher
$(document).on('click', '.bhub-switch', function () {
  const $this = $(this)
  const input = $(this).find('input')
  input.val(input.val() === '1' ? '0' : '1')
  input.trigger('change')

  $this.toggleClass('bhub-checked')
})

// Choose
$(document).on('click', '.bhub-choose .bhub-choose-item', function () {
  let wrapper = $(this)
  let radio = $(this).find('input')

  wrapper
    .siblings()
    .removeClass('bhub-checked')
    .find('input[type="radio"]')
    .prop('checked', false)
  wrapper.addClass('bhub-checked')
  radio.prop('checked', true)
  radio.trigger('change')
})

// bhub Radio
$(document).on('click', '.bhub-radio .bhub-radio-item', function () {
  let wrapper = $(this)
  let radio = $(this).find('input')

  wrapper
    .siblings()
    .removeClass('bhub-checked')
    .find('input[type="radio"]')
    .prop('checked', false)
  wrapper.addClass('bhub-checked')
  radio.prop('checked', true)
  radio.trigger('change')
})

// WP Style Tabs
$('.bhub-wp-tabs .nav-tab-wrapper a').on('click', function (e) {
  var currentTab = $(this).attr('href')
  var tabsContainer = $(this).closest('.bhub-wp-tabs')

  tabsContainer.find('.tab-content').removeClass('bhub-active')
  $(currentTab).addClass('bhub-active')

  tabsContainer.find('.nav-tab').removeClass('nav-tab-active')
  $(this).addClass('nav-tab-active')

  e.preventDefault()
})
